import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const FileIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.59375 0.382812H0V2.13281V7.38281H8.75V2.13281H6.125L4.59375 0.382812Z"
        fill={fillColor || '#212121'}
      />
    </svg>
  );
};

export { FileIcon };
